<template>
  <v-dialog v-model="show" width="500" persistent>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>Preferences</v-card-title>
      <preferences/>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" flat @click="$emit('closed')">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Preferences from '@/ux/components/Preferences.vue';

export default {
  name: 'preferences-modal',
  components: { Preferences },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
  }),
  methods:
    {
    },
};
</script>

<style>
</style>
